<template>
<div class="container-fluid">
	<div class="footer-wrap">
		<div class="footer-row">
			<div class="footer-info">
				<div class="footer-title">携手合作 共创共赢未来</div>
				<div class="footer-desc">一站式人力资源数字化解决方案，让人才管理更简单、更精准。</div>
			</div>
			<div class="footer-btn-wrap">
				<span @click="showPop" class="free">
					申请免费试用
					<img src="../assets/icon_jiantou.png" class="footer-btn-icon" />
				</span>
			</div>
		</div>
	</div>
	<div class="footer-bottom">
		<div class="footer-bottom-row">
			<div class="footer-left">
				<div class="left-title">
					电话咨询
				</div>
				<div class="left-desc">
					0755-29986289
				</div>
				<div class="left-title">
					工作时间
				</div>
				<div class="left-desc">
					周一至周日（8:00-22:00）
				</div>
				<div class="left-title">
					联系邮箱
				</div>
				<div class="left-desc">
					jl@szrcjy.com
				</div>
				<div class="left-title">
					公司地址
				</div>
				<div class="left-desc">
					深圳市宝安区沙井街道沙一社区新沙路与新民南路交界处京基御景珑庭7栋A101
				</div>
			</div>
			<div class="footer-center"></div>
			<div class="footer-right">
				<div>
					<img src="../assets/icon_lianxi.png" style="width: 30px;height: 30px;margin-right: 8px;transform: translateY(-3px);"/>
					<span style="font-size: 24px;font-weight: 900;color: #ffffff;display: inline-block;height: 32px;line-height: 32px;">联系我们</span>
				</div>
				<div style="margin-top: 12px;font-size: 14px;color: #9A9FA9;">
					如果您对我们的合作方案感兴趣，或希望了解更多细节，欢迎随时联系我们。我们期待与您携手合作，共同开创未来的成功与辉煌
				</div>
				<div class="footer-qr-wrap">
					<div class="footer-qr-item">
						<div class="hhdImg">
							<img src="../assets/pic_01.png" class="hhdImg"/>
						</div>
						<div class="desc">智灵工抖音小程序</div>
					</div>
					<div class="footer-qr-item">
						<div class="hhdImg">
							<img src="../assets/pic_02.png" class="hhdImg"/>
						</div>
						<div class="desc">智灵工小程序</div>
					</div>
					<div class="footer-qr-item">
						<div class="hhdImg">
							<img src="../assets/pic_03.png" class="hhdImg"/>
						</div>
						<div class="desc">智灵工企业服务号</div>
					</div>
					<div class="footer-qr-item">
						<div class="hhdImg">
							<img src="../assets/pic_04.png" class="hhdImg"/>
						</div>
						<div class="desc">智灵工视频号</div>
					</div>
				</div>
			</div>
		</div>
		<div class="footer-bottom-copy">
			<div class="copy">
				©{{currentYear}}深圳市智灵工科技有限公司 版权所有 技术支持：武汉市创云智汇网络科技有限公司
			</div>
			<div class="copy" style="margin-top: 16px;">
				<span style="margin-left: 20px;" @click="goUrl"> 粤ICP备2025429195号-1</span>
			</div>
		</div>
	</div>
</div>
</template>
<script>
	import "../js/bootstrap.bundle.min.js"
	export default {
			name: 'footer',
			props: {
			msg: String
		},
		data() {
			return {
				currentYear: new Date().getFullYear()
			};
		},
		created() {
			
		},
		methods: {
			goUrl(){
				window.open('https://beian.miit.gov.cn/');
			},
			showPop(){
				this.$emit('pop',true);
			}
		}
	}
</script>

<style scoped>
	@import url("../css/bootstrap.min.css");
	.footer-bottom-copy{
		text-align: center;
		margin-top: 28px;
		padding-bottom: 20px;
	}
	.footer-wrap {
		background-image: url("../assets/pic_bg.png");
		background-size: cover;
		background-repeat: no-repeat;
		background-position: right center;
		width: 100%;
		padding: 58px 12.5%;
		height: auto;
		flex-wrap: wrap;
		align-items: flex-start;
		justify-content: space-between;
		box-sizing: border-box;
	}
	.footer-qr-wrap{
		display: flex;
		margin-top: 15px;
	}

	.footer-qr-item:last-child{
		margin-right: 0;
	}
	.footer-row {
		margin: 0 auto;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 0 12.5%;
	}
	.footer-info {
		width: 70%;
		min-width: 200px;
	}
	.footer-title {
		font-size: 24px;
		font-weight: 700;
		color: #3D3D3D;
	}
	.footer-desc {
		font-size: 18px;
		color: #3D3D3D;
		margin-top: 20px;
	}
	.footer-btn-wrap {
		width: 30%;
		min-width: 120px;
		text-align: right;
		margin-top: 23px;
		display: flex;
		justify-content: flex-end;
		align-items: flex-start;
	}
	.free {
		background: #006DF3;
		font-size: 18px;
		font-weight: 700;
		height: 40px;
		line-height: 40px;
		padding: 7px 22px;
		color: #ffffff;
		border-radius: 80px;
		display: inline-flex;
		align-items: center;
		cursor: pointer;
	}
	.footer-btn-icon {
		width: 26px;
		height: 26px;
		margin-left: 8px;
	}
	.footer-left {
		min-width: 33%;
		margin-bottom: 24px;
	}
	.footer-center {
		width: 17%;
	}
	.footer-right {
		flex: 1 1 300px;
		min-width: 50%;
		margin-bottom: 24px;
		text-align: left;
	}
	.hhdImg {
		height: auto;
		width: 100%;
		transition: transform 0.3s ease;
	}
	.hhdImg:hover {
		transform: scale(1.1);
	}
	.free {
		background: #006DF3;
		font-size: 18px;
		font-weight: 700;
		height: 40px;
		line-height: 40px;
		padding: 7px 22px;
		color: #ffffff;
		border-radius: 80px;
	}
	.free:hover {
		cursor: pointer;
	}
	.copy {
		font-size: 14px;
		font-weight: 400;
		color: #999999;
		height: 20px;
		line-height: 20px;
		margin-top: 16px;
	}
	.desc {
		font-size: 14px;
		font-weight: 700;
		margin-top: 12px;
		height: 46px;
		line-height: 46px;
		color: #ffffff;
		text-align: center;
	}
	/* 二维码横向滚动容器 */
	.qr-scroll {
		display: flex;
		overflow-x: auto;
		gap: 24px;
		margin-top: 32px;
	}
	.qr-item {
		min-width: 123px;
		text-align: center;
	}
	.left-desc{
		color: #ffffff;
		font-size: 16px;
		font-weight: 700;
		margin-top: 5px;
	}
	.left-title{
		color: #9A9FA9;
		font-size: 14px;
		font-weight: 700;
		margin-top: 16px;
	}

	.footer-bottom{
		background: #080F1D;
		padding: 60px 12.5%;
		text-align: left;
	}
	.footer-bottom-row{
		border-bottom: 1px solid #314162;
		padding-bottom: 10px;
		display: flex;
	}
	.footer-qr-item{
		text-align: left;
		flex:1;
		margin-right: 20px;
	}
	/* 响应式断点 */
	@media (max-width: 1024px) {
		.footer-bottom{
			background: #080F1D;
			padding: 22px 12.5%;
			text-align: left;
		}
		.footer-bottom-row{
			border-bottom: 1px solid #314162;
			padding-bottom: 10px;
			display: flex;
		}
		.footer-left{
			min-width: 33%;
			display: inline-block;
		}
		.footer-center{
			min-width: auto;
		}
		.footer-right{
			min-width: 50%;
			display: inline-block;
			text-align: left;
		}
		.footer-row{
			display: flex;
			align-items: flex-start;
			width: 100%;
			justify-content: space-between;
		}
	}
	@media (max-width: 600px) {
		.desc {
			font-size: 10px;
			font-weight: 500;
			margin-top: 12px;
			height: 23px;
			line-height: 23px;
			color: #ffffff;
			text-align: center;
		}
		.footer-qr-item{
			text-align: left;
			flex:1;
			margin-right: 5px;
		}
		.footer-bottom-row{
			border-bottom: 1px solid #314162;
			padding-bottom: 10px;
			display: block;
		}
		.footer-left{
			display: block;
			width: 100%;
		}
		.footer-center{
			display: none;
		}
		.footer-right{
			display: block;
			text-align: left;
			width: 100%;
		}
		.footer-row {
		    flex-direction: column;
    		align-items: center;
    		text-align: left;
    		padding: 0 12.5%;
  		}
		.footer-info,
		.footer-btn-wrap {
			width: 100%;
			min-width: 0;
			text-align: left;
			margin: 0;
			justify-content: left;
		}
		.footer-btn-wrap {
			margin-top: 18px;
			display: flex;
			justify-content: left;
			align-items: center;
		}
		.footer-title {
			font-size: 20px;
		}
		.footer-desc {
			font-size: 14px;
			margin-top: 12px;
		}
		.free {
			font-size: 16px;
			padding: 6px 16px;
			height: 36px;
			line-height: 36px;
		}
		.footer-btn-icon {
			width: 20px;
			height: 20px;
		}
		.copy {
			font-size: 12px;
		}
		.free {
			font-size: 14px;
			padding: 5px 12px;
		}
		.hhdImg {
			width: 80px;
			height: 80px;
		}
		.qr-scroll {
			gap: 12px;
			margin-top: 16px;
		}
		.footer-bottom{
			background: #080F1D;
			padding: 20px;
			text-align: left;
		}
}
</style>
